@if (data) {
	<div class="searchdex-body">
		@if (seoHeadline) {
			<h2>{{ seoHeadline }}</h2>
		}
		@if (tabs) {
			<mat-accordion [multi]="true">
				@for (tab of tabs; track $index) {
					<mat-expansion-panel [expanded]="true">
						<mat-expansion-panel-header>
							<mat-panel-title>
								{{ tab.heading }}
							</mat-panel-title>
						</mat-expansion-panel-header>
						<div
							[innerHtml]="tab.content"
							class="searchdex-body-content">
						</div>
					</mat-expansion-panel>
				}
				@if (featuredLinks.length > 0) {
					<mat-expansion-panel [expanded]="true" class="searchdex-featured-categories">
						<mat-expansion-panel-header>
							<mat-panel-title> Featured Categories </mat-panel-title>
						</mat-expansion-panel-header>
						<ul>
							@for (link of featuredLinks; track trackByTarget($index, link)) {
								<li>
									<a [href]="link.target">{{ link.text }}</a>
								</li>
							}
						</ul>
					</mat-expansion-panel>
				}
			</mat-accordion>
		}
		</div>
}

